// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit Course Page - HOME Pattern Styling */
.edit-course-main-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 20px;
  max-width: none;
}

/* Header Section */
.edit-course-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.course-context {
  display: flex;
  align-items: center;
  gap: 10px;
}

.course-context h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
}

.race-context {
  margin: 5px 0 0 0;
  color: #7f8c8d;
  font-size: 14px;
}

.race-context strong {
  color: #4A90E2;
  font-weight: 600;
}

.header-actions {
  margin-left: auto;
  display: flex;
  gap: 12px;
}

.manual-link {
  padding: 8px 16px;
  background: transparent;
  color: #4A90E2;
  border: 1px solid #4A90E2;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.manual-link:hover {
  background: #4A90E2;
  color: white;
}

/* Save Button */
.save-course-button {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: linear-gradient(135deg, #4A90E2 0%, #7B68EE 100%);
  color: white;
}

.save-course-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
}

.save-course-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Loading and Error States */
.edit-course-loading,
.edit-course-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 20px;
  text-align: center;
  color: white;
}

.edit-course-loading p,
.edit-course-error p {
  margin: 16px 0;
  color: white;
  font-size: 16px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.edit-course-error {
  gap: 16px;
}

/* Course Configuration Section */
.course-configuration {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e9ecef;
  margin-bottom: 24px;
}

/* Position Info */
.position-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
}

.position-display {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}

.position-display:last-child {
  margin-bottom: 0;
}

.position-display strong {
  color: #2c3e50;
  min-width: 140px;
}

.no-position {
  color: #dc3545;
  font-style: italic;
}

/* Course Actions */
.course-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.set-position-button,
.advance-view-button {
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 2px solid transparent;
}

.set-position-button {
  background: #28a745;
  color: white;
}

.set-position-button:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-2px);
}

.set-position-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.advance-view-button {
  background: linear-gradient(135deg, #4A90E2 0%, #7B68EE 100%);
  color: white;
}

.advance-view-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
}

/* Error Messages */
.form-error {
  padding: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  margin-bottom: 20px;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Spinner Animation */
.spinner,
.spinner-small {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner {
  width: 40px;
  height: 40px;
}

.spinner-small {
  width: 16px;
  height: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ===== FULL SCREEN MAP CONTAINER (like WatchLive) ===== */
.edit-course-map-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  display: block;
}

/* Map View - Full Screen Mode */
.edit-course-map-container .course-map-view {
  position: absolute !important;
  top: 60px !important; /* Header is exactly 60px */
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: calc(100vh - 60px) !important;
  min-width: 320px !important;
  min-height: 500px !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  z-index: 1 !important;
  overflow: hidden !important;
  visibility: visible !important;
  opacity: 1 !important;
  background: white;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  border: none !important;
}

/* Legacy course-map-view styles (kept for backwards compatibility) */
.course-map-view {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999 !important;
  overflow: hidden !important;
  background: white;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  border: none !important;
}

/* Hide MapHeader in legacy full-screen map view only */
.course-map-view:not(.edit-course-map-container .course-map-view) .map-header {
  display: none !important;
}

/* Message containers in map view */
.edit-course-map-container .no-course-message,
.edit-course-map-container .map-error-recovery {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
}

.edit-course-map-container .no-course-message h3,
.edit-course-map-container .map-error-recovery h3 {
  margin: 20px 0 10px 0;
  color: #2c3e50;
  font-size: 18px;
}

.edit-course-map-container .no-course-message p,
.edit-course-map-container .map-error-recovery p {
  margin: 10px 0 20px 0;
  color: #7f8c8d;
  line-height: 1.5;
}

.edit-course-map-container .back-to-config-button {
  padding: 12px 20px;
  background: #4A90E2;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.edit-course-map-container .back-to-config-button:hover {
  background: #357ABD;
}

/* Ensure map takes full space */
.course-map-view .unified-course-map,
.course-map-view .unified-course-map > div {
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}

.table-view-error h3 {
  margin: 1rem 0;
  color: #495057;
  font-size: 1.5rem;
}

.table-view-error p {
  margin: 1rem 0;
  color: #6c757d;
  line-height: 1.5;
}

.table-view-error .error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.table-view-error .back-button,
.table-view-error .save-first-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.table-view-error .back-button {
  background: #6c757d;
  color: white;
}

.table-view-error .back-button:hover {
  background: #545b62;
}

.table-view-error .save-first-button {
  background: #007bff;
  color: white;
}

.table-view-error .save-first-button:hover:not(:disabled) {
  background: #0056b3;
}

.table-view-error .save-first-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

/* Ensure the map container fills the entire screen */
.course-map-view .unified-course-map {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

/* Make sure the UnifiedCourseMap takes full space */
.course-map-view .unified-course-map > div {
  width: 100% !important;
  height: 100% !important;
}

/* Remove any scrolling from the parent container when in map view */
.edit-course-page:has(.course-map-view) {
  overflow: hidden !important;
  height: 100vh !important;
}

/* Ultra-compact header for mobile */
.edit-course-map-header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1001 !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 4px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 60px; /* Single row height */
  overflow: hidden;
}

/* Single row flex container */
.header-single-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  gap: 4px;
}

/* Left side - compact title */
.map-title-compact {
  flex-shrink: 0;
  min-width: 80px;
}

.map-title-compact h2 {
  font-size: 12px;
  margin: 0;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
}

/* Center controls - main button group */
.center-controls {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1;
  justify-content: center;
  overflow: hidden;
}

/* Right controls - save button */
.right-controls {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* Compact button styles for single row */
.edit-course-map-header button {
  min-height: 36px;
  min-width: 36px;
  padding: 4px 8px;
  border: none;
  border-radius: 6px;
  background: var(--fleetly-primary-navy);
  color: white;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* Specific button colors with higher specificity */
.edit-course-map-header .back-to-edit-button {
  background: #757575 !important;
  color: white !important;
}

.edit-course-map-header .drop-mark-button {
  background: var(--fleetly-accent-orange) !important;
  color: white !important;
}

.edit-course-map-header .reset-view-button {
  background: var(--fleetly-secondary-teal) !important;
  color: white !important;
}

.edit-course-map-header .save-course-button {
  background: var(--fleetly-accent-blue) !important;
  color: white !important;
  min-width: 48px; /* Slightly wider for save */
}

/* Save button in page header */
.header-actions .save-course-button {
  background: var(--fleetly-accent-blue);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
}

.header-actions .save-course-button:hover {
  background: var(--fleetly-accent-blue-dark);
}

.header-actions .save-course-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Mark mode button colors */
.edit-course-map-header .mark-mode.ideal {
  background: var(--fleetly-secondary-teal) !important;
  color: white !important;
}

.edit-course-map-header .mark-mode.actual {
  background: var(--fleetly-accent-orange) !important;
  color: white !important;
}

.edit-course-map-header .mark-mode.both {
  background: var(--fleetly-accent-purple) !important;
  color: white !important;
}

/* Disabled state */
.edit-course-map-header button:disabled {
  background: #bdbdbd !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

/* Ensure icons are visible */
.edit-course-map-header button svg,
.edit-course-map-header button i {
  color: inherit !important;
  opacity: 1 !important;
}

/* Spinner animation */
.spinner-small {
  width: 12px;
  height: 12px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Mobile responsive - hide text on very small screens */
@media (max-width: 480px) {
  .edit-course-map-header button span {
    display: none; /* Icon only on small screens */
  }
  
  .edit-course-map-header button {
    min-width: 32px;
    min-height: 32px;
    padding: 2px;
    gap: 0;
  }
  
  .map-title-compact h2 {
    font-size: 10px;
  }
  
  .center-controls {
    gap: 1px;
  }
}

/* Extra small screens - even more compact */
@media (max-width: 360px) {
  .map-title-compact {
    min-width: 60px;
  }
  
  .map-title-compact h2 {
    font-size: 9px;
  }
  
  .edit-course-map-header button {
    min-width: 28px;
    min-height: 28px;
    font-size: 12px;
  }
  
  .edit-course-map-header {
    padding: 2px 4px;
    max-height: 40px;
  }
  
  .header-single-row {
    min-height: 36px;
  }
}

/* Hover effects - desktop only */
@media (min-width: 481px) and (hover: hover) {
  .edit-course-map-header button:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  .edit-course-map-header .back-to-edit-button:hover {
    background: #616161 !important;
  }
  
  .edit-course-map-header .drop-mark-button:hover {
    background: #F7521A !important;
  }
  
  .edit-course-map-header .reset-view-button:hover {
    background: #42C2BB !important;
  }
  
  .edit-course-map-header .save-course-button:hover {
    background: var(--fleetly-accent-blue-dark, #3A9BC1) !important;
  }
}

/* Course actions for configuration view */
.course-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.course-actions button {
  min-height: 44px;
  padding: 12px 16px;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  color: white;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Specific button colors */
.set-position-button {
  background: var(--fleetly-primary-navy);
}

.advance-view-button {
  background: var(--fleetly-accent-orange);
}

.table-mode-button {
  background: var(--fleetly-accent-purple);
}

.table-mode-button:hover {
  background: var(--fleetly-accent-purple-dark, #6B2F7C);
}

.lay-course-button {
  background: var(--fleetly-secondary-teal);
}

@media (min-width: 768px) {
  .course-actions {
    flex-direction: row;
    justify-content: space-between;
  }
  
  .course-actions button {
    flex: 1;
    max-width: 200px;
  }
  
  .edit-course-map-header {
    padding: 8px;
    max-height: none;
  }
  
  .edit-course-map-header button {
    min-height: 40px;
    padding: 8px 12px;
    font-size: 12px;
  }
  
  .edit-course-map-header button span {
    display: inline;
  }
}

/* No course marks message */
.no-course-marks-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
  background: #f5f5f5;
}

.no-course-marks-message h3 {
  margin: 16px 0 8px 0;
  color: #333;
}

.no-course-marks-message p {
  margin: 0 0 16px 0;
  color: #666;
}

/* Add these enhanced styles to EditCourse.css */

/* Drop mode - anchor going down (orange/red) */
.edit-course-map-header .drop-mark-button.drop-mode {
  background: var(--fleetly-accent-orange) !important; /* Orange for dropping */
  color: white !important;
  position: relative;
}

/* Lift mode - arrow going up (blue) */
.edit-course-map-header .drop-mark-button.lift-mode {
  background: var(--fleetly-primary-navy) !important; /* Navy for lifting */
  color: white !important;
  position: relative;
}

/* Add subtle animation hints for better UX */
.edit-course-map-header .drop-mark-button.drop-mode svg {
  animation: dropHint 2s ease-in-out infinite;
  transform-origin: center;
}

.edit-course-map-header .drop-mark-button.lift-mode svg {
  animation: liftHint 2s ease-in-out infinite;
  transform-origin: center;
}

/* Drop animation - gentle downward motion */
@keyframes dropHint {
  0%, 100% { 
    transform: translateY(0) scale(1); 
  }
  50% { 
    transform: translateY(1px) scale(1.05); 
  }
}

/* Lift animation - gentle upward motion */
@keyframes liftHint {
  0%, 100% { 
    transform: translateY(0) scale(1); 
  }
  50% { 
    transform: translateY(-1px) scale(1.05); 
  }
}

/* Enhanced hover states */
@media (min-width: 481px) and (hover: hover) {
  .edit-course-map-header .drop-mark-button.drop-mode:hover {
    background: #F7521A !important; /* Darker orange on hover */
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(249, 99, 50, 0.3);
  }
  
  .edit-course-map-header .drop-mark-button.lift-mode:hover {
    background: #15304A !important; /* Darker navy on hover */
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(27, 58, 87, 0.3);
  }
}

/* Disable animations on mobile to save battery */
@media (max-width: 480px) {
  .edit-course-map-header .drop-mark-button svg {
    animation: none;
  }
}

/* Add status indicator dots */
.edit-course-map-header .drop-mark-button::after {
  content: '';
  position: absolute;
  top: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1px solid white;
}

.edit-course-map-header .drop-mark-button.drop-mode::after {
  background: var(--fleetly-secondary-teal); /* Teal dot for ideal position */
}

.edit-course-map-header .drop-mark-button.lift-mode::after {
  background: var(--fleetly-accent-orange); /* Orange dot for dropped marks */
}

/* ===== NEW SHARED MAPHEADER STYLES ===== */
/* Selected mark header - positioned below the shared MapHeader */
.selected-mark-header {
  position: fixed;
  top: 60px; /* Position below MapHeader */
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(248, 249, 250, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected-mark-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--fleetly-primary-navy);
  font-size: 0.9rem;
  font-weight: 500;
}

.no-selection-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--fleetly-muted-dark);
  font-size: 0.85rem;
  font-style: italic;
}

.selected-mark-label strong {
  color: var(--fleetly-accent-blue);
}

/* Adjust map content area to account for both headers */
.course-map-view .unified-course-map {
  margin-top: 100px !important; /* Space for both MapHeader (60px) and selected-mark-header (40px) */
}

/* Mobile responsiveness for selected mark header */
@media (max-width: 768px) {
  .selected-mark-header {
    padding: 6px 12px;
    min-height: 36px;
  }
  
  .selected-mark-info,
  .no-selection-info {
    font-size: 0.8rem;
  }
  
  .course-map-view .unified-course-map {
    margin-top: 96px !important; /* Smaller headers on mobile */
  }
}

/* ===== MOBILE RESPONSIVE FIXES FOR EDIT COURSE ===== */

/* Fix 1: Header - Stack Back Button and Title on Mobile */
@media (max-width: 768px) {
  .edit-course-main-section {
    padding: 20px;
    margin: 10px;
    border-radius: 12px;
  }
  
  .edit-course-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 16px;
  }
  
  .course-context {
    width: 100%;
  }
  
  .course-context h3 {
    font-size: 18px;
  }
  
  .race-context {
    font-size: 13px;
  }
  
  .header-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }
  
  .save-course-button {
    width: 100%;
    justify-content: center;
  }
}

/* Fix 2: Position Display - Stack Labels and Values Vertically on Mobile */
@media (max-width: 768px) {
  .position-info {
    padding: 16px;
    margin-bottom: 20px;
  }
  
  .position-display {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 16px;
    padding: 10px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }
  
  .position-display:last-child {
    margin-bottom: 0;
  }
  
  .position-display strong {
    min-width: auto;
    width: 100%;
    font-size: 13px;
    color: #666;
    font-weight: 600;
  }
  
  /* Coordinate values */
  .position-display strong + * {
    width: 100%;
    font-size: 14px;
    color: #2c3e50;
    font-family: monospace;
    word-break: break-all;
  }
  
  .no-position {
    font-size: 13px;
  }
}

/* Fix 3: Course Actions - Full Width Buttons on Mobile */
@media (max-width: 768px) {
  .course-actions {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .set-position-button,
  .advance-view-button,
  .table-mode-button,
  .lay-course-button {
    width: 100%;
    justify-content: center;
    padding: 14px 16px;
    font-size: 15px;
  }
}

/* Extra Small Devices (< 480px) */
@media (max-width: 480px) {
  .edit-course-main-section {
    padding: 16px;
    margin: 5px;
    border-radius: 8px;
  }
  
  .edit-course-header {
    gap: 10px;
  }
  
  .course-context h3 {
    font-size: 16px;
  }
  
  .position-info {
    padding: 12px;
  }
  
  .position-display {
    padding: 8px;
  }
  
  .position-display strong {
    font-size: 12px;
  }
  
  .position-display strong + * {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/EditCourse.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;;EAEE,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,oBAAoB,EAAE,2BAA2B;EACjD,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,eAAe,EAAE,4BAA4B;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,wDAAwD;AACxD;EACE;IACE,aAAa,EAAE,+BAA+B;EAChD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+DAA+D;EACjE;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,OAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,gDAAgD;;AAEhD,+CAA+C;AAC/C;EACE,mDAAmD,EAAE,wBAAwB;EAC7E,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,kDAAkD,EAAE,qBAAqB;EACzE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,iCAAiC;EACnC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,8BAA8B,EAAE,2BAA2B;IAC3D,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,8BAA8B,EAAE,yBAAyB;IACzD,2BAA2B;IAC3B,2CAA2C;EAC7C;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC,EAAE,gCAAgC;AAC7E;;AAEA;EACE,wCAAwC,EAAE,iCAAiC;AAC7E;;AAEA,4CAA4C;AAC5C,iEAAiE;AACjE;EACE,eAAe;EACf,SAAS,EAAE,6BAA6B;EACxC,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wDAAwD;AACxD;EACE,4BAA4B,EAAE,oEAAoE;AACpG;;AAEA,mDAAmD;AACnD;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B,EAAE,8BAA8B;EAC7D;AACF;;AAEA,wDAAwD;;AAExD,0DAA0D;AAC1D;EACE;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Edit Course Page - HOME Pattern Styling */\n.edit-course-main-section {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 20px;\n  max-width: none;\n}\n\n/* Header Section */\n.edit-course-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.course-context {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.course-context h3 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.race-context {\n  margin: 5px 0 0 0;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n.race-context strong {\n  color: #4A90E2;\n  font-weight: 600;\n}\n\n.header-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 12px;\n}\n\n.manual-link {\n  padding: 8px 16px;\n  background: transparent;\n  color: #4A90E2;\n  border: 1px solid #4A90E2;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.manual-link:hover {\n  background: #4A90E2;\n  color: white;\n}\n\n/* Save Button */\n.save-course-button {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  background: linear-gradient(135deg, #4A90E2 0%, #7B68EE 100%);\n  color: white;\n}\n\n.save-course-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);\n}\n\n.save-course-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Loading and Error States */\n.edit-course-loading,\n.edit-course-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 20px;\n  text-align: center;\n  color: white;\n}\n\n.edit-course-loading p,\n.edit-course-error p {\n  margin: 16px 0;\n  color: white;\n  font-size: 16px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.edit-course-error {\n  gap: 16px;\n}\n\n/* Course Configuration Section */\n.course-configuration {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e9ecef;\n  margin-bottom: 24px;\n}\n\n/* Position Info */\n.position-info {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  border: 1px solid #e9ecef;\n}\n\n.position-display {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n}\n\n.position-display:last-child {\n  margin-bottom: 0;\n}\n\n.position-display strong {\n  color: #2c3e50;\n  min-width: 140px;\n}\n\n.no-position {\n  color: #dc3545;\n  font-style: italic;\n}\n\n/* Course Actions */\n.course-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.set-position-button,\n.advance-view-button {\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 2px solid transparent;\n}\n\n.set-position-button {\n  background: #28a745;\n  color: white;\n}\n\n.set-position-button:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-2px);\n}\n\n.set-position-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.advance-view-button {\n  background: linear-gradient(135deg, #4A90E2 0%, #7B68EE 100%);\n  color: white;\n}\n\n.advance-view-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);\n}\n\n/* Error Messages */\n.form-error {\n  padding: 16px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Spinner Animation */\n.spinner,\n.spinner-small {\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n}\n\n.spinner-small {\n  width: 16px;\n  height: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ===== FULL SCREEN MAP CONTAINER (like WatchLive) ===== */\n.edit-course-map-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  overflow: hidden;\n  background: #f5f5f5;\n  display: block;\n}\n\n/* Map View - Full Screen Mode */\n.edit-course-map-container .course-map-view {\n  position: absolute !important;\n  top: 60px !important; /* Header is exactly 60px */\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: calc(100vh - 60px) !important;\n  min-width: 320px !important;\n  min-height: 500px !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  z-index: 1 !important;\n  overflow: hidden !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  background: white;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n  border: none !important;\n}\n\n/* Legacy course-map-view styles (kept for backwards compatibility) */\n.course-map-view {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: 9999 !important;\n  overflow: hidden !important;\n  background: white;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n  border: none !important;\n}\n\n/* Hide MapHeader in legacy full-screen map view only */\n.course-map-view:not(.edit-course-map-container .course-map-view) .map-header {\n  display: none !important;\n}\n\n/* Message containers in map view */\n.edit-course-map-container .no-course-message,\n.edit-course-map-container .map-error-recovery {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  width: 90%;\n}\n\n.edit-course-map-container .no-course-message h3,\n.edit-course-map-container .map-error-recovery h3 {\n  margin: 20px 0 10px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.edit-course-map-container .no-course-message p,\n.edit-course-map-container .map-error-recovery p {\n  margin: 10px 0 20px 0;\n  color: #7f8c8d;\n  line-height: 1.5;\n}\n\n.edit-course-map-container .back-to-config-button {\n  padding: 12px 20px;\n  background: #4A90E2;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 auto;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.edit-course-map-container .back-to-config-button:hover {\n  background: #357ABD;\n}\n\n/* Ensure map takes full space */\n.course-map-view .unified-course-map,\n.course-map-view .unified-course-map > div {\n  width: 100% !important;\n  height: 100% !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n}\n\n.table-view-error h3 {\n  margin: 1rem 0;\n  color: #495057;\n  font-size: 1.5rem;\n}\n\n.table-view-error p {\n  margin: 1rem 0;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n.table-view-error .error-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.table-view-error .back-button,\n.table-view-error .save-first-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.table-view-error .back-button {\n  background: #6c757d;\n  color: white;\n}\n\n.table-view-error .back-button:hover {\n  background: #545b62;\n}\n\n.table-view-error .save-first-button {\n  background: #007bff;\n  color: white;\n}\n\n.table-view-error .save-first-button:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.table-view-error .save-first-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Ensure the map container fills the entire screen */\n.course-map-view .unified-course-map {\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n/* Make sure the UnifiedCourseMap takes full space */\n.course-map-view .unified-course-map > div {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Remove any scrolling from the parent container when in map view */\n.edit-course-page:has(.course-map-view) {\n  overflow: hidden !important;\n  height: 100vh !important;\n}\n\n/* Ultra-compact header for mobile */\n.edit-course-map-header {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  z-index: 1001 !important;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 4px 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  max-height: 60px; /* Single row height */\n  overflow: hidden;\n}\n\n/* Single row flex container */\n.header-single-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 48px;\n  gap: 4px;\n}\n\n/* Left side - compact title */\n.map-title-compact {\n  flex-shrink: 0;\n  min-width: 80px;\n}\n\n.map-title-compact h2 {\n  font-size: 12px;\n  margin: 0;\n  color: #333;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Center controls - main button group */\n.center-controls {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex: 1;\n  justify-content: center;\n  overflow: hidden;\n}\n\n/* Right controls - save button */\n.right-controls {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* Compact button styles for single row */\n.edit-course-map-header button {\n  min-height: 36px;\n  min-width: 36px;\n  padding: 4px 8px;\n  border: none;\n  border-radius: 6px;\n  background: var(--fleetly-primary-navy);\n  color: white;\n  font-size: 10px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n/* Specific button colors with higher specificity */\n.edit-course-map-header .back-to-edit-button {\n  background: #757575 !important;\n  color: white !important;\n}\n\n.edit-course-map-header .drop-mark-button {\n  background: var(--fleetly-accent-orange) !important;\n  color: white !important;\n}\n\n.edit-course-map-header .reset-view-button {\n  background: var(--fleetly-secondary-teal) !important;\n  color: white !important;\n}\n\n.edit-course-map-header .save-course-button {\n  background: var(--fleetly-accent-blue) !important;\n  color: white !important;\n  min-width: 48px; /* Slightly wider for save */\n}\n\n/* Save button in page header */\n.header-actions .save-course-button {\n  background: var(--fleetly-accent-blue);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n}\n\n.header-actions .save-course-button:hover {\n  background: var(--fleetly-accent-blue-dark);\n}\n\n.header-actions .save-course-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Mark mode button colors */\n.edit-course-map-header .mark-mode.ideal {\n  background: var(--fleetly-secondary-teal) !important;\n  color: white !important;\n}\n\n.edit-course-map-header .mark-mode.actual {\n  background: var(--fleetly-accent-orange) !important;\n  color: white !important;\n}\n\n.edit-course-map-header .mark-mode.both {\n  background: var(--fleetly-accent-purple) !important;\n  color: white !important;\n}\n\n/* Disabled state */\n.edit-course-map-header button:disabled {\n  background: #bdbdbd !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n/* Ensure icons are visible */\n.edit-course-map-header button svg,\n.edit-course-map-header button i {\n  color: inherit !important;\n  opacity: 1 !important;\n}\n\n/* Spinner animation */\n.spinner-small {\n  width: 12px;\n  height: 12px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Mobile responsive - hide text on very small screens */\n@media (max-width: 480px) {\n  .edit-course-map-header button span {\n    display: none; /* Icon only on small screens */\n  }\n  \n  .edit-course-map-header button {\n    min-width: 32px;\n    min-height: 32px;\n    padding: 2px;\n    gap: 0;\n  }\n  \n  .map-title-compact h2 {\n    font-size: 10px;\n  }\n  \n  .center-controls {\n    gap: 1px;\n  }\n}\n\n/* Extra small screens - even more compact */\n@media (max-width: 360px) {\n  .map-title-compact {\n    min-width: 60px;\n  }\n  \n  .map-title-compact h2 {\n    font-size: 9px;\n  }\n  \n  .edit-course-map-header button {\n    min-width: 28px;\n    min-height: 28px;\n    font-size: 12px;\n  }\n  \n  .edit-course-map-header {\n    padding: 2px 4px;\n    max-height: 40px;\n  }\n  \n  .header-single-row {\n    min-height: 36px;\n  }\n}\n\n/* Hover effects - desktop only */\n@media (min-width: 481px) and (hover: hover) {\n  .edit-course-map-header button:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  .edit-course-map-header .back-to-edit-button:hover {\n    background: #616161 !important;\n  }\n  \n  .edit-course-map-header .drop-mark-button:hover {\n    background: #F7521A !important;\n  }\n  \n  .edit-course-map-header .reset-view-button:hover {\n    background: #42C2BB !important;\n  }\n  \n  .edit-course-map-header .save-course-button:hover {\n    background: var(--fleetly-accent-blue-dark, #3A9BC1) !important;\n  }\n}\n\n/* Course actions for configuration view */\n.course-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.course-actions button {\n  min-height: 44px;\n  padding: 12px 16px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: none;\n  color: white;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Specific button colors */\n.set-position-button {\n  background: var(--fleetly-primary-navy);\n}\n\n.advance-view-button {\n  background: var(--fleetly-accent-orange);\n}\n\n.table-mode-button {\n  background: var(--fleetly-accent-purple);\n}\n\n.table-mode-button:hover {\n  background: var(--fleetly-accent-purple-dark, #6B2F7C);\n}\n\n.lay-course-button {\n  background: var(--fleetly-secondary-teal);\n}\n\n@media (min-width: 768px) {\n  .course-actions {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  \n  .course-actions button {\n    flex: 1;\n    max-width: 200px;\n  }\n  \n  .edit-course-map-header {\n    padding: 8px;\n    max-height: none;\n  }\n  \n  .edit-course-map-header button {\n    min-height: 40px;\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n  \n  .edit-course-map-header button span {\n    display: inline;\n  }\n}\n\n/* No course marks message */\n.no-course-marks-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 20px;\n  text-align: center;\n  background: #f5f5f5;\n}\n\n.no-course-marks-message h3 {\n  margin: 16px 0 8px 0;\n  color: #333;\n}\n\n.no-course-marks-message p {\n  margin: 0 0 16px 0;\n  color: #666;\n}\n\n/* Add these enhanced styles to EditCourse.css */\n\n/* Drop mode - anchor going down (orange/red) */\n.edit-course-map-header .drop-mark-button.drop-mode {\n  background: var(--fleetly-accent-orange) !important; /* Orange for dropping */\n  color: white !important;\n  position: relative;\n}\n\n/* Lift mode - arrow going up (blue) */\n.edit-course-map-header .drop-mark-button.lift-mode {\n  background: var(--fleetly-primary-navy) !important; /* Navy for lifting */\n  color: white !important;\n  position: relative;\n}\n\n/* Add subtle animation hints for better UX */\n.edit-course-map-header .drop-mark-button.drop-mode svg {\n  animation: dropHint 2s ease-in-out infinite;\n  transform-origin: center;\n}\n\n.edit-course-map-header .drop-mark-button.lift-mode svg {\n  animation: liftHint 2s ease-in-out infinite;\n  transform-origin: center;\n}\n\n/* Drop animation - gentle downward motion */\n@keyframes dropHint {\n  0%, 100% { \n    transform: translateY(0) scale(1); \n  }\n  50% { \n    transform: translateY(1px) scale(1.05); \n  }\n}\n\n/* Lift animation - gentle upward motion */\n@keyframes liftHint {\n  0%, 100% { \n    transform: translateY(0) scale(1); \n  }\n  50% { \n    transform: translateY(-1px) scale(1.05); \n  }\n}\n\n/* Enhanced hover states */\n@media (min-width: 481px) and (hover: hover) {\n  .edit-course-map-header .drop-mark-button.drop-mode:hover {\n    background: #F7521A !important; /* Darker orange on hover */\n    transform: translateY(-1px);\n    box-shadow: 0 3px 6px rgba(249, 99, 50, 0.3);\n  }\n  \n  .edit-course-map-header .drop-mark-button.lift-mode:hover {\n    background: #15304A !important; /* Darker navy on hover */\n    transform: translateY(-1px);\n    box-shadow: 0 3px 6px rgba(27, 58, 87, 0.3);\n  }\n}\n\n/* Disable animations on mobile to save battery */\n@media (max-width: 480px) {\n  .edit-course-map-header .drop-mark-button svg {\n    animation: none;\n  }\n}\n\n/* Add status indicator dots */\n.edit-course-map-header .drop-mark-button::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  border: 1px solid white;\n}\n\n.edit-course-map-header .drop-mark-button.drop-mode::after {\n  background: var(--fleetly-secondary-teal); /* Teal dot for ideal position */\n}\n\n.edit-course-map-header .drop-mark-button.lift-mode::after {\n  background: var(--fleetly-accent-orange); /* Orange dot for dropped marks */\n}\n\n/* ===== NEW SHARED MAPHEADER STYLES ===== */\n/* Selected mark header - positioned below the shared MapHeader */\n.selected-mark-header {\n  position: fixed;\n  top: 60px; /* Position below MapHeader */\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: rgba(248, 249, 250, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 8px 16px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.selected-mark-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--fleetly-primary-navy);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.no-selection-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--fleetly-muted-dark);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.selected-mark-label strong {\n  color: var(--fleetly-accent-blue);\n}\n\n/* Adjust map content area to account for both headers */\n.course-map-view .unified-course-map {\n  margin-top: 100px !important; /* Space for both MapHeader (60px) and selected-mark-header (40px) */\n}\n\n/* Mobile responsiveness for selected mark header */\n@media (max-width: 768px) {\n  .selected-mark-header {\n    padding: 6px 12px;\n    min-height: 36px;\n  }\n  \n  .selected-mark-info,\n  .no-selection-info {\n    font-size: 0.8rem;\n  }\n  \n  .course-map-view .unified-course-map {\n    margin-top: 96px !important; /* Smaller headers on mobile */\n  }\n}\n\n/* ===== MOBILE RESPONSIVE FIXES FOR EDIT COURSE ===== */\n\n/* Fix 1: Header - Stack Back Button and Title on Mobile */\n@media (max-width: 768px) {\n  .edit-course-main-section {\n    padding: 20px;\n    margin: 10px;\n    border-radius: 12px;\n  }\n  \n  .edit-course-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    padding-bottom: 16px;\n  }\n  \n  .course-context {\n    width: 100%;\n  }\n  \n  .course-context h3 {\n    font-size: 18px;\n  }\n  \n  .race-context {\n    font-size: 13px;\n  }\n  \n  .header-actions {\n    width: 100%;\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n  \n  .save-course-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Fix 2: Position Display - Stack Labels and Values Vertically on Mobile */\n@media (max-width: 768px) {\n  .position-info {\n    padding: 16px;\n    margin-bottom: 20px;\n  }\n  \n  .position-display {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    margin-bottom: 16px;\n    padding: 10px;\n    background: white;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0;\n  }\n  \n  .position-display:last-child {\n    margin-bottom: 0;\n  }\n  \n  .position-display strong {\n    min-width: auto;\n    width: 100%;\n    font-size: 13px;\n    color: #666;\n    font-weight: 600;\n  }\n  \n  /* Coordinate values */\n  .position-display strong + * {\n    width: 100%;\n    font-size: 14px;\n    color: #2c3e50;\n    font-family: monospace;\n    word-break: break-all;\n  }\n  \n  .no-position {\n    font-size: 13px;\n  }\n}\n\n/* Fix 3: Course Actions - Full Width Buttons on Mobile */\n@media (max-width: 768px) {\n  .course-actions {\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n  \n  .set-position-button,\n  .advance-view-button,\n  .table-mode-button,\n  .lay-course-button {\n    width: 100%;\n    justify-content: center;\n    padding: 14px 16px;\n    font-size: 15px;\n  }\n}\n\n/* Extra Small Devices (< 480px) */\n@media (max-width: 480px) {\n  .edit-course-main-section {\n    padding: 16px;\n    margin: 5px;\n    border-radius: 8px;\n  }\n  \n  .edit-course-header {\n    gap: 10px;\n  }\n  \n  .course-context h3 {\n    font-size: 16px;\n  }\n  \n  .position-info {\n    padding: 12px;\n  }\n  \n  .position-display {\n    padding: 8px;\n  }\n  \n  .position-display strong {\n    font-size: 12px;\n  }\n  \n  .position-display strong + * {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
